import React, {useMemo} from 'react';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import useSyncPromise from '../../utils/react/useSyncPromise';
import {formatArea, formatDistance} from '../../utils/formatters';
import fetchUser from '../../utils/gaia/fetchUser';
import turfArea from '@turf/area';
import polygonToLine from '@turf/polygon-to-line';
import turfLength from '@turf/length';

interface AreaStatsProps extends React.HTMLProps<HTMLDivElement> {
    area: Area;
}

export default function AreaStats({area, ...props}: AreaStatsProps) {
    const [user] = useSyncPromise(fetchUser());
    const computedArea = useMemo(
        () => area.isGeometryLoaded && turfArea(area.unmodifiedArea),
        [area.isGeometryLoaded, area.unmodifiedArea],
    );
    const perimeter = useMemo(
        () => area.isGeometryLoaded &&
                turfLength(polygonToLine(area.unmodifiedArea), {units: 'meters'}),
        [area.isGeometryLoaded, area.unmodifiedArea],
    );

    if (user && computedArea && perimeter) {
        return <div {...props}>
            <Typography color='inherit' variant='body1' style={{fontSize: 12}}>
                <strong>Area:</strong> {formatArea(computedArea, user)}
            </Typography>
            <Typography color='inherit' variant='body1' style={{fontSize: 12}}>
                <strong>Perimeter:</strong> {formatDistance(perimeter, user)}
            </Typography>
        </div>;
    } else {
        return <div {...props} style={{height: 36, ...props.style}}>
            <CircularProgress disableShrink thickness={7} style={{height: 36, width: 36}} />
        </div>;
    }
}
